import { createContext } from 'react';

import { Command } from '@components/features/CommandMenu/types';

export interface CommandContextValue {
  isOpen: boolean;
  open(): void;
  query: string;
  startAsyncLoad: () => () => void;
  setQuery: (query: string) => void;
  register: (command: Command) => void;
  unregister: (command: Command) => void;
}

export const CommandContext = createContext<CommandContextValue>({
  isOpen: false,
  open: () => {},
  query: '',
  startAsyncLoad: () => () => {},
  setQuery: () => {},
  register: () => {},
  unregister: () => {},
});
